<template>
    <div class="rootPage">
        <!-- 头部 -->
        <v-head :menu="menu"></v-head>
        <!-- 侧边栏 -->
        <v-slider :menu="menu"></v-slider>
        <div class="content">
            <keep-alive>
                <router-view v-if='this.$route.meta.keepAlive'></router-view>
            </keep-alive>
            <router-view v-if='!this.$route.meta.keepAlive'></router-view>
            <copyRight class="copyRight"></copyRight>
        </div>
    </div>
</template>

<script>
import vHead from "./header.vue";
import vSlider from "./slider.vue";
import copyRight from "./../common/copyRight.vue";
import menu from "./../../router/router.js";
export default {
  data() {
    return {
      menu: []
    };
  },
  components: {
    vHead,
    vSlider,
    copyRight
  },
  created() {
    this.accessMap();
  },
  mounted() {
    // console.log(menu);
  },
  methods: {
    accessMap() {
      let self = this;
      $http.POST({
        url: this.$store.state.apiUrl + "/api/services/app/AdminUser/AccessMap",
        success(res) {
          // console.log(res)
          self.menu = res;
          if (res.length) {
            self.headerLoading = false;
          }
        },
        fail(res) {}
      });
    }
  }
};
</script>

<style lang='scss' scoped>
.rootPage {
  padding: 70px 0 0 220px;
  .content {
    box-sizing: border-box;
  }
  //版权
  .copyRight {
    padding-top: 30px;
    padding-bottom: 20px;
  }
}
</style>
